var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TextInput',{attrs:{"value":_vm.value && _vm.value.label},on:{"input":_vm.updateLabel}})
}
var staticRenderFns = []

export { render, staticRenderFns }